<script setup lang="ts">

</script>

<template>
<div>
  <h2>Stránka nebola nájdená.</h2>
</div>
</template>

<style scoped>

</style>
